// This is the javascript entrypoint for the featured-collection section.
// This file and all its inclusions will be processed through postcss
import '@archetype-themes/scripts/modules/product-ajax-form'
class FeaturedTagTabs extends HTMLElement {
    constructor() {
      super();
  
      this.buttons = this.querySelectorAll('.featured-tag-button');
      this.tabs = this.querySelectorAll('.featured-tag-tab');
      this.showmore = this.querySelector('.featured-tag-button--showmore');
      this.headButtons = this.querySelector('.featured-tag-buttons');
      
      Array.from(this.buttons).forEach(function(btn){
        btn.addEventListener('click', this.switchTab.bind(this));
      }, this);
      this.showmore.addEventListener('click', this.showTagbutton.bind(this));
    }
  
    switchTab (e) {
      e.preventDefault();
      let tab_index = e.target.dataset.index;
      Array.from(this.buttons).forEach(function(btn){
        if(btn.dataset.index != tab_index) {
          btn.classList.remove('active');
        }else {
          btn.classList.add('active');
        }
      }, this);
      Array.from(this.tabs).forEach(function(tab){
        if(tab.dataset.index != tab_index) {
          tab.classList.remove('active');
        }else {
          tab.classList.add('active');
        }
      }, this);
    }

  showTagbutton(e){
      e.preventDefault();
      if(this.showmore.classList.contains('show')){
        this.headButtons.style.maxHeight = '130px';
        this.showmore.classList.remove('show');
        this.headButtons.style.paddingBottom = '0';
      } else {
        this.headButtons.style.maxHeight = 'unset';
        this.headButtons.style.paddingBottom = '20px';
        this.showmore.classList.add('show');
      }
    }
  }
  
  customElements.define('featured-tag-tabs', FeaturedTagTabs);